const images = {
  loginBG: require("../assets/images/loginBG.jpg"),
  pdmo_logo: require("../assets/images/pdmo_logo.png"),
  empty_image: require("../assets/images/empty_image.png"),
  template_image: require("../assets/images/template_image.png"),
  template_mobile_image: require("../assets/images/template_mobile_image.png"),
  HTML5_Logo: require("../assets/images/HTML5_Logo.png"),
  Ipv6_Logo: require("../assets/images/Ipv6_Logo.png"),
  W3c_Css_Logo: require("../assets/images/W3c_Css_Logo.png"),
  Wcag_2_AA_Logo: require("../assets/images/Wcag_2_AA_Logo.png"),

  QRCode: require("../assets/images/QRCode.png"),
  E_SDG_logo: require("../assets/images/SDGs/E_SDG_logo.png"),
  E_SDG_logo01 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-01.jpg"),
  E_SDG_logo02 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-02.jpg"),
  E_SDG_logo03 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-03.jpg"),
  E_SDG_logo04 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-04.jpg"),
  E_SDG_logo05 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-05.jpg"),
  E_SDG_logo06 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-06.jpg"),
  E_SDG_logo07 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-07.jpg"),
  E_SDG_logo08 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-08.jpg"),
  E_SDG_logo09 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-09.jpg"),
  E_SDG_logo10 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-10.jpg"),
  E_SDG_logo11 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-11.jpg"),
  E_SDG_logo12 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-12.jpg"),
  E_SDG_logo13 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-13.jpg"),
  E_SDG_logo14 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-14.jpg"),
  E_SDG_logo15 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-15.jpg"),
  E_SDG_logo16 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-16.jpg"),
  E_SDG_logo17 : require("../assets/images/SDGs/icon_sdgs/E_SDG_Icons-17.jpg"),
  icon_excel : require("../assets/images/icon/icon_excel.png"),
  icon_word : require("../assets/images/icon/icon_word.png"),
};
export default images;
